const IDENTITY_VERIFICATION_PHOTOS_MAX_SIZE_MB = 6;
const IDENTITY_VERIFICATION_PHOTOS_QUALITY = 0.8;

const PATTERNS = {
  dniAndDl: /^[0-9]{8}[a-zA-Z]$/,
  dni: /^[0-9]{8}[a-zA-Z]$/,
  nie: /^[a-zA-Z][0-9]{7}[a-zA-Z]$/,
  name: /^[A-Za-zÀ-ÖØ-öø-ÿ]*(?:\s[A-Za-zÀ-ÖØ-öø-ÿ]+)*(?:\s[а-яА-ЯёЁ]+)*$/,
  nameWithoutAccents: /^[A-Za-z]+(?:\s[A-Za-z]+)*(?:\s[äöüßéèòàùì']+)*$/,
  fiscalCode: /^[A-Za-z0-9]+$/,
  email:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/,
  docNumber: /^\s*[a-zA-Z0-9\s]*$/,
  docNumberWithDots: /^\s*[a-zA-Z0-9 .:\s]*$/,
  time: /\d{2}:\d{2}/,
  numbers: /\D/g,
  onlyNumbers: /^[0-9]*$/,
  phone: /^\+?[1-9]\d{1,14}$/,
};

const DATE_FORMAT = 'YYYY-MM-DD';

enum LANGUAGE_CODES {
  en = 'en',
  es = 'es',
  it = 'it',
  de = 'de',
  fr = 'fr',
  nl = 'nl',
  ko = 'ko',
  hu = 'hu',
  ru = 'ru',
  cs = 'cs',
  bg = 'bg',
  pt = 'pt',
  ro = 'ro',
  et = 'et',
  pl = 'pl',
  ca = 'ca',
  el = 'el',
  uk = 'uk',
}

const LANGUAGES_ISO_3: {[key: string]: string} = {
  es: 'spa',
  it: 'ita',
  en: 'eng',
  fr: 'fra',
  nl: 'nld',
  ko: 'kor',
  ru: 'rus',
  pt: 'por',
  de: 'deu',
  hu: 'hun',
  cs: 'ces',
  ro: 'ron',
  fn: 'fin',
  bg: 'bul',
  et: 'est',
};

enum PAYMENT_METHOD_TYPES {
  payOnline = 'PAY_ONLINE',
  payLater = 'PAY_LATER',
  payOnArrival = 'PAY_ON_ARRIVAL',
}

const ORIGINS = {
  guestApp: 'GUEST_APP',
  guestAppV2: 'GUEST_APP_V2',
  embeddedGuestApp: 'EMBEDDED_GUEST_APP',
  avantio: 'AVANTIO',
  guesty: 'GUESTY',
  guesty2: 'GUESTY_2',
  oracle: 'ORACLE',
  mews2: 'MEWS_2',
};

enum CURRENCIES {
  eur = 'eur',
  usd = 'usd',
  gbp = 'gbp',
  aed = 'aed',
  czk = 'czk',
  chf = 'chf',
}

const CURRENCIES_SIGNS: Record<CURRENCIES, string> = {
  [CURRENCIES.eur]: '€',
  [CURRENCIES.usd]: '$',
  [CURRENCIES.gbp]: '£',
  [CURRENCIES.aed]: 'د.إ',
  [CURRENCIES.czk]: 'Kč',
  [CURRENCIES.chf]: '₣',
};

enum DAY_NAMES {
  monday = 'MON',
  tuesday = 'TUE',
  wednesday = 'WED',
  thursday = 'THU',
  friday = 'FRI',
  saturday = 'SAT',
  sunday = 'SUN',
}

const NONE_EXEMPTION = 'NONE';

export {
  DATE_FORMAT,
  PATTERNS,
  LANGUAGE_CODES,
  LANGUAGES_ISO_3,
  PAYMENT_METHOD_TYPES,
  ORIGINS,
  CURRENCIES,
  DAY_NAMES,
  NONE_EXEMPTION,
  CURRENCIES_SIGNS,
  IDENTITY_VERIFICATION_PHOTOS_MAX_SIZE_MB,
  IDENTITY_VERIFICATION_PHOTOS_QUALITY,
};
